<template>
  <div class="text-center" id="principal">
    <h1>Loja do representante Grupo K1</h1>
    <div>
      <span>
        <ul v-for="dado in dados" :key="dado.id">
          <b-card>
            <li class="list-unstyled">
              {{ dado.Referencia }}
              <br />
              <img :src="dado.Imagens" width="100px" height="100px" />
            </li>
          </b-card>
        </ul>
      </span>
    </div>
  </div>
</template>

<script>
import dados from "../../../services/cores.json";
export default {
  data() {
    return {
      dados: dados.Cores,
    };
  },
};
</script>

<style scoped>
#principal {
  width: 100%;
}
</style>
